<template>
  <div
    id="home-disclamer">
    <v-layout
      row
      wrap>
      <v-flex
        style="align-self: center; justify-self: center"
        data-aos="fade-up"
        xs12
        sm12
        md6>
        <p
          :style="$vuetify.breakpoint.mdAndUp ? '':'max-width: 100% !important; margin-top: 20px'"
          class="home-disclamer-title">
          "Para mi ejercer medicina es apostolado, es cooperar con la sanidad de Dios con la Ciencia, para la recuperación de tu salud"
        </p>
        <p
          style="margin-bottom: 50px"
          class="home-disclamer-subtitle">
          Dr. David Aguirre Mar
        </p>
      </v-flex>
      <v-flex
        data-aos="fade-up"
        xs12
        sm12
        md6>
        <iframe 
          width="100%" 
          height="600" 
          src="https://www.youtube.com/embed/0Ed7JfNcnj8" 
          title="David Aguirre Mar mural" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen></iframe>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  
}
</script>
<style scoped>
.home-disclamer-subtitle {
  font-family: 'Open sans' ,sans-serif;
  color: black;
  font-weight: 600;
  font-size: 20px;
  text-align: left;
  margin-top: 50px;
}
.home-disclamer-title {
  max-width: 80%;
  font-family: 'Open sans' ,sans-serif;
  color: black;
  font-weight: 500;
  font-size: 34px;
  text-align: left;
} 
#home-disclamer {
  box-shadow: 0px 6px 11px 2px rgb(0 0 0 / 31%);
  background-image: url('/img/static/testimony-card-background.png');
  padding-top: 50px;
  padding-bottom: 100px;
  padding-left: 10%;
  padding-right: 10%;
  background-color: white;
  position: relative;
  z-index: 2;
  height: auto; 
}
</style>